import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ArrowDown, ArrowUpRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Container } from '@components/common/Container';
import { AnchorLink, BodyText, EditorialHeader, InlineNotice, Overline, PageSection, SectionTitle, TextLink } from '@components/common/Editorial';
import { ProductGrid } from '@components/product/ProductGrid';
import { PlanComparison } from '@components/product/PlanComparison';
import { products } from '@data/products';
import { usePageTitle } from '@hooks/usePageTitle';
export const ProductsPage = () => {
    const { t } = useTranslation();
    usePageTitle('productsPage.title');
    const services = products.filter((product) => product.category !== 'software' && !product.variants);
    const plans = products.filter((product) => product.variants);
    const software = products.filter((product) => product.category === 'software');
    return (_jsxs(_Fragment, { children: [_jsxs(EditorialHeader, { eyebrow: t('home.showcase.eyebrow'), title: t('interior.catalog.title'), intro: t('interior.catalog.intro'), children: [_jsxs(AnchorLink, { href: "#catalog-services", children: [t('interior.catalog.services'), _jsx(ArrowDown, { size: 16, "aria-hidden": "true" })] }), _jsxs(AnchorLink, { href: "#catalog-software", children: [t('home.software.eyebrow'), _jsx(ArrowDown, { size: 16, "aria-hidden": "true" })] }), _jsxs(AnchorLink, { href: "#catalog-plans", children: [t('personalCare360.catalogTitle'), _jsx(ArrowDown, { size: 16, "aria-hidden": "true" })] })] }), _jsx(PageSection, { id: "catalog-services", "aria-labelledby": "catalog-services-title", children: _jsxs(Container, { children: [_jsxs(CatalogNotice, { children: [_jsxs(InlineNotice, { children: [_jsx("strong", { children: t('productsPage.catalogNoteTitle') }), _jsx("p", { children: t('personalCare360.existingDemoNote') })] }), _jsx("span", { children: t('home.showcase.illustrations') })] }), _jsxs(GroupHeading, { children: [_jsxs(Overline, { children: ["01 / ", t('interior.catalog.services')] }), _jsx(SectionTitle, { id: "catalog-services-title", children: t('home.showcase.servicesTitle') }), _jsx(BodyText, { children: t('home.showcase.servicesIntro') })] }), _jsx(ProductGrid, { products: services })] }) }), _jsx(PageSection, { id: "catalog-plans", "aria-labelledby": "catalog-plans-title", children: _jsxs(Container, { children: [_jsxs(Overline, { children: ["02 / ", t('personalCare360.premium')] }), _jsx(SectionTitle, { id: "catalog-plans-title", children: t('personalCare360.catalogTitle') }), _jsx(ProductGrid, { products: plans })] }) }), _jsx(PlanComparison, {}), _jsx(SoftwareSection, { id: "catalog-software", "aria-labelledby": "catalog-software-title", children: _jsxs(Container, { children: [_jsxs(Overline, { children: ["03 / ", t('home.software.eyebrow')] }), _jsx(SectionTitle, { id: "catalog-software-title", children: t('interior.catalog.softwareTitle') }), _jsx(BodyText, { children: t('home.software.text') }), _jsx(ProductGrid, { products: software }), _jsxs(HelpLine, { children: [_jsx("p", { children: t('interior.catalog.help') }), _jsxs(TextLink, { to: "/contact", children: [t('actions.requestAssistance'), _jsx(ArrowUpRight, { size: 18, "aria-hidden": "true" })] })] })] }) })] }));
};
const CatalogNotice = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 3rem;
  > span {
    color: ${({ theme }) => theme.colors.muted};
    font-size: 0.75rem;
  }
`;
const GroupHeading = styled.div `
  padding-bottom: 2rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.navy900};
`;
const SoftwareSection = styled(PageSection) `
  background: ${({ theme }) => theme.colors.surface};
`;
const HelpLine = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem 2rem;
  padding-top: 2rem;
  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.muted};
    font-size: 1rem;
  }
`;
